<template>
  <div class="animated fadeIn">
    <div class="page-header d-flex" style="margin: 12px 12px 5px 12px;">
      <h4 class="page-title">
        <i class="fas fa-download"></i>
        WEBCastle(Web Application Firewall) Dashboard
      </h4>
      <ul class="breadcrumbs ml-auto">
          <li class="nav-home mr-1">
              <a href="#">
                <i class="fas fa-home text-muted"></i>
              </a>
          </li>
          <li class="nav-item">
              <a class="font_15" href="#">WEBCastle</a>
          </li>
          <li class="separator">
              <i class="fa fa-angle-right"></i>
          </li>
          <li class="nav-item">
              <a class="font_15 font-weight-bold" href="#">Dashboard</a>
          </li>
      </ul>
    </div>
    <b-card>
      <!-- <template slot="header">
        <i class='fa fa-align-justify'></i> WEBCastle(Web Application Firewall) Dashboard
      </template> -->
        <b-row>
          <b-col sm="6" lg="4">
            <b-card no-body class="bg-primary">
              <b-card-body class="pb-0">
                <h1><strong>
                  <number ref="module_check_1" :from="0" :to="info && info.module && info.module.alive + info.module.deleted > 0 ? info.module.alive + info.module.deleted : 0" :format="value_comma" :duration="2"/>
                  <sup style="font-size: 20px"> 설치</sup></strong></h1>
                <hr>
                <h6>최근 정보</h6>
                <h4>사용중 :
                  <number ref="module_check_2" :from="0" :to="info && info.module && info.module.alive > 0 ? info.module.alive : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>미사용 :
                  <number ref="module_check_3" :from="0" :to="info && info.module && info.module.deleted > 0 ? info.module.deleted : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>전체 :
                  <number ref="module_check_4" :from="0" :to="info && info.module && info.module.deleted > 0 ? info.module.alive + info.module.deleted : 0" :format="value_comma" :duration="2"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="4">
            <b-card no-body class="bg-warning">
              <b-card-body class="pb-0" >
                <h1><strong>
                  <number ref="detect_check_1" :from="0" :to="info && info.day && info.day.detect > 0 ? info.day.detect : 0" :format="value_comma" :duration="2"/>
                  <sup style="font-size: 20px"> 탐지</sup></strong></h1>
                <hr>
                <h6>최근 정보</h6>
                <h4>오늘 :
                  <number ref="detect_check_2" :from="0" :to="info && info.day && info.day.detect > 0 ? info.day.detect : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>최근 7일 :
                  <number ref="detect_check_3" :from="0" :to="info && info.week && info.week.detect > 0 ? info.week.detect : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>이번 달 :
                  <number ref="detect_check_4" :from="0" :to="info && info.month && info.month.detect > 0 ? info.month.detect : 0" :format="value_comma" :duration="2"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
          <b-col sm="6" lg="4">
            <b-card no-body class="bg-danger">
              <b-card-body class="pb-0">
                <h1><strong>
                  <number ref="block_check_1" :from="0" :to="info && info.day && info.day.block > 0 ? info.day.block : 0" :format="value_comma" :duration="2"/>
                  <sup style="font-size: 20px"> 차단</sup></strong></h1>
                <hr>
                <h6>최근 정보</h6>
                <h4>오늘 :
                  <number ref="block_check_2" :from="0" :to="info && info.day && info.day.block > 0 ? info.day.block : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>최근 7일 :
                  <number ref="block_check_3" :from="0" :to="info && info.week && info.week.block > 0 ? info.week.block : 0" :format="value_comma" :duration="2"/>
                </h4>
                <h4>이번 달 :
                  <number ref="block_check_4" :from="0" :to="info && info.month && info.month.block > 0 ? info.month.block : 0" :format="value_comma" :duration="2"/>
                </h4>
              </b-card-body>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
      <logList :only_view="true"/>
      <hr>

    <b-card ref="_ms">
      <b-row>
        <b-col class="title">
          서버 목록 (Max 100)
          <b-button class="float-right btn-addition" variant='success' to="/downloads/">다운로드</b-button>
        </b-col>
      </b-row>
      <hr>
      <b-row v-if="load_agent != undefined && load_agent.length > 0">
        <agent-item  v-for="item in load_agent" :key="item.id" :item="item" :use_view="use_view" :list="pong.list"></agent-item>
      </b-row>
      <b-row v-else style="text-align:center;">
        <b-col sm="6" lg="12">
          <b-card no-body class="bg-success">
            <b-card-body class="pb-20">
                <h3 class="mb-0">No Firewall Installed</h3>
            </b-card-body>
          </b-card>
        </b-col>
      </b-row>
    </b-card>

    <router-view ></router-view>
  </div>
</template>

<script>
  import App from './app.js'; export default Object.assign({}, App);
</script>
